import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useCallback, useEffect } from 'react';
import isAfter from 'date-fns/isAfter';
import PollManager from '../../../services/poller/PollManager.js';
import { getHostName } from '../../../services/apiEndpoint/apiEndpoint.js';
import { getRssiLatestAsync, triggerRefreshRssi, triggerRefreshDECTRssi } from './RssiSlice.js';

var state = {
  NULL: 'null',
  POLLING: 'polling',
  TOO_LOW: 'low_signal',
  TOO_HIGH: 'high_signal',
  OK: 'good_signal',
  RETRY: 'retry',
  ERROR: 'error'
};
var LOW_THRESHOLD_PERCENTAGE = 22;
var useRssi = function useRssi(client, giid, deviceLabel, getErrorMessage) {
  var measurementTypes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ['RADIO_RSSI'];
  var rssiStatekey = 'rssiState';
  var rssiTriggerKey = 'rssiTrigger';
  var _useState = useState(state.NULL),
    _useState2 = _slicedToArray(_useState, 2),
    rssiState = _useState2[0],
    setRssiState = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    triggerDateStamp = _useState6[0],
    setTriggerDateStamp = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    rssiMeasurement = _useState8[0],
    setRssiMeasurement = _useState8[1];
  var stopRssiTrigger = function stopRssiTrigger() {
    PollManager.cancel(rssiTriggerKey);
  };
  var stopRssiScan = function stopRssiScan() {
    PollManager.cancel(rssiStatekey);
    stopRssiTrigger();
    setRssiState(state.RETRY);
  };
  var startRssiTrigger = function startRssiTrigger(date) {
    if (date && !triggerDateStamp) {
      setTriggerDateStamp(date);
    }
    return PollManager.poll( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!measurementTypes.includes('DECT_RSSI')) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return triggerRefreshDECTRssi(client, giid);
            case 3:
              if (!(measurementTypes.includes('RADIO_RSSI') || measurementTypes.includes('WLAN_RSSI'))) {
                _context.next = 6;
                break;
              }
              _context.next = 6;
              return triggerRefreshRssi(client, giid);
            case 6:
              return _context.abrupt("return", false);
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), {
      key: rssiTriggerKey,
      interval: 15000,
      timeout: Infinity
    });
  };
  var stopAllPolling = function stopAllPolling() {
    PollManager.cancel(rssiTriggerKey);
    PollManager.cancel(rssiStatekey);
  };
  var rssiMeasurementIsNotDoneYet = function rssiMeasurementIsNotDoneYet(deviceUnderTest) {
    return measurementTypes.map(function (type) {
      return deviceUnderTest.gateways.filter(function (gw) {
        return gw.rssiType === type;
      }).map(function (gw) {
        return gw.rssiValue;
      }).every(function (val) {
        return val === -128;
      });
    }).some(function (noMeasurement) {
      return noMeasurement === true;
    });
  };
  var measurementIsDoneBeforeTheTestWasTriggered = function measurementIsDoneBeforeTheTestWasTriggered(deviceUnderTest, timestamp) {
    return !deviceUnderTest.gateways.filter(function (gw) {
      return measurementTypes.includes(gw.rssiType);
    }).every(function (gateway) {
      if (getHostName() === 'local-mypages.verisure.com') {
        return true;
      }
      return isAfter(new Date(gateway.timestamp), timestamp);
    });
  };
  var signalStrengthIsOk = function signalStrengthIsOk(deviceUnderTest) {
    return deviceUnderTest.deviceValidStatus;
  };
  var signalStrengthIsOkForTheTypesWeMeasure = function signalStrengthIsOkForTheTypesWeMeasure(deviceUnderTest) {
    return measurementTypes.map(function (type) {
      return deviceUnderTest.gateways.filter(function (gw) {
        return gw.rssiType === type;
      }).some(function (gw) {
        return gw.validStatus === true;
      });
    }).every(Boolean);
  };
  var hasALowSignal = function hasALowSignal(deviceUnderTest) {
    return deviceUnderTest.gateways.filter(function (gw) {
      return measurementTypes.includes(gw.rssiType);
    }).map(function (gw) {
      return gw.rssiPercentage;
    }).some(function (val) {
      return val < LOW_THRESHOLD_PERCENTAGE;
    });
  };
  var checkRsi = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var now;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            now = new Date();
            startRssiTrigger(now);
            return _context3.abrupt("return", PollManager.poll( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
              var _yield$getRssiLatestA, devices, deviceUnderTest, fatal;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return getRssiLatestAsync(client, giid);
                    case 2:
                      _yield$getRssiLatestA = _context2.sent;
                      devices = _yield$getRssiLatestA.devices;
                      setRssiMeasurement(devices);
                      deviceUnderTest = devices.find(function (dev) {
                        return dev.device.deviceLabel === deviceLabel;
                      });
                      if (deviceUnderTest) {
                        _context2.next = 11;
                        break;
                      }
                      stopAllPolling();
                      fatal = new Error('device not found');
                      fatal.code = 'RSSI_NO_DEVICE';
                      throw fatal;
                    case 11:
                      if (!(measurementIsDoneBeforeTheTestWasTriggered(deviceUnderTest, triggerDateStamp || now) || rssiMeasurementIsNotDoneYet(deviceUnderTest))) {
                        _context2.next = 14;
                        break;
                      }
                      setRssiState(state.POLLING);
                      return _context2.abrupt("return", false);
                    case 14:
                      if (!(signalStrengthIsOk(deviceUnderTest) || signalStrengthIsOkForTheTypesWeMeasure(deviceUnderTest))) {
                        _context2.next = 18;
                        break;
                      }
                      setRssiState(state.OK);
                      stopRssiTrigger();
                      return _context2.abrupt("return", true);
                    case 18:
                      if (!hasALowSignal(deviceUnderTest)) {
                        _context2.next = 21;
                        break;
                      }
                      setRssiState(state.TOO_LOW);
                      return _context2.abrupt("return", false);
                    case 21:
                      setRssiState(state.TOO_HIGH);
                      return _context2.abrupt("return", false);
                    case 23:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), {
              key: rssiStatekey
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [deviceLabel, giid, triggerDateStamp]);
  var parseError = function parseError(e) {
    // stopAllPolling();
    if (e.code === 'POLL_TIMEOUT') {
      setRssiState(state.RETRY);
    } else {
      var _getErrorMessage = getErrorMessage(e),
        description = _getErrorMessage.description;
      setError(description);
      setRssiState(state.ERROR);
    }
  };
  var startRssiScan = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            setRssiState(state.POLLING);
            _context4.next = 4;
            return checkRsi();
          case 4:
            _context4.next = 9;
            break;
          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](0);
            parseError(_context4.t0);
          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 6]]);
  })), [checkRsi]);
  useEffect(function () {
    return function () {
      return stopAllPolling();
    };
  }, []);
  return {
    startRssiScan: startRssiScan,
    rssiState: rssiState,
    error: error,
    startRssiTrigger: startRssiTrigger,
    stopRssiScan: stopRssiScan,
    rssiMeasurement: rssiMeasurement
  };
};

export { state, useRssi };
